import React, { useEffect, useState } from "react";
import "../styles/LiveSurvey.css";
import TruveyGreenLogo from "../Asset/Images/XSO-Green.png";
import { useParams,Link } from "react-router-dom";
import SurveyRunService from "../Services/SurveyRunService";
import apiService from "../Services/apiService";

const UserRunSurvey = () => {
    const { uniqueKey } = useParams();
    const token = localStorage.getItem("JWTToken");
    const [surveyStatus, setSurveyStatus] = useState("");
    const [surveyName, setSurveyName] = useState();
    const [responderName, setResponderName] = useState();
    const [description, setDescription] = useState();
    const [isSurveyStarted, setIsSurveyStarted] = useState(false);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [questionDetails, setQuestionDetails] = useState([]);
    const [answers, setAnswers] = useState({});
    const [isLoading, setLoading] = useState(true);
    const [CompanyLogo, setCompanyLogo] = useState("");

    useEffect(() => {
        const GetSurveyData = async () => {
            const response = await SurveyRunService.GetSurveyDetailsByResponder(uniqueKey, token);
            if (response) {
                setSurveyStatus(response.Status || "");
                const Data = response.RESPONSE;
                   if(Data[0].CompanyLogo!==""){
                    setCompanyLogo(Data[0].CompanyLogo);
                }
                setSurveyName(Data[0]?.SurveyName);
                setResponderName(Data[0]?.ResponderName);
                setDescription(Data[0]?.Description);
            }
        };

        const fetchQuestionData = async () => {
            try {
                const response = await apiService.GetQuestionDetails(token, uniqueKey);
                if (response && response.SURVEY_DETAILS) {
                    console.log(response);
                    setQuestionDetails(response.SURVEY_DETAILS);
                } else {
                    console.error("No survey details found");
                }
            } catch (error) {
                console.error("Error fetching survey data", error);
            } finally {
                setLoading(false);
            }
        };

        GetSurveyData();
        fetchQuestionData();
    }, [token, uniqueKey]);

    const handleAnswerChange = (questionId, answer) => {
        setAnswers((prevAnswers) => ({
            ...prevAnswers,
            [questionId]: answer,
        }));
    };

    const handleNext = () => {
        if (currentQuestionIndex < questionDetails.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const handleStartSurvey = () => {
        setIsSurveyStarted(true);
    };

    const renderQuestion = (question) => {
        switch (question.OptionType) {
            case "Multiple Choice":
                return question.Options?.map((option, index) => (
                    <div key={index}>
                        <input
                            type="radio"
                            name={`question-${question.QuestionId}`}
                            value={option}
                            onChange={() => handleAnswerChange(question.QuestionId, option)}
                        />
                        {option}
                    </div>
                ));
            case "Check Boxes":
                return question.Options?.map((option, index) => (
                    <div key={index}>
                        <input
                            type="checkbox"
                            name={`question-${question.QuestionId}`}
                            value={option}
                            onChange={(e) => {
                                const value = e.target.checked
                                    ? [...(answers[question.QuestionId] || []), option]
                                    : (answers[question.QuestionId] || []).filter(
                                          (ans) => ans !== option
                                      );
                                handleAnswerChange(question.QuestionId, value);
                            }}
                        />
                        {option}
                    </div>
                ));
            case "Short Answer":
                return (
                    <input
                        type="text"
                        className="form-control"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            case "Paragraph":
                return (
                    <textarea
                        className="form-control"
                        rows="4"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            case "Date":
                return (
                    <input
                        type="date"
                        className="form-control"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            case "Answer in Number":
                return (
                    <input
                        type="number"
                        className="form-control"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            case "Mobile Number":
                return (
                    <input
                        type="tel"
                        className="form-control"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            case "Email":
                return (
                    <input
                        type="email"
                        className="form-control"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            case "Rating Bar":
                return (
                    <input
                        type="range"
                        min="1"
                        max="5"
                        className="form-range"
                        onChange={(e) => handleAnswerChange(question.QuestionId, e.target.value)}
                    />
                );
            default:
                return <div>Unsupported question type</div>;
        }
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="container-fluid bg-grey py-3">
            <div className="container min-hight85vh d-flex align-items-center">
                <div className="text-center mb-3">
                    <div className="mb-3 p-3">
                        <Link to="/" className="">   <img src={CompanyLogo && CompanyLogo !== "" ? CompanyLogo : TruveyGreenLogo} alt="Truvey Logo" className="Img-Set" /></Link>
                    </div>
                </div>
                <div className="min-hight75vh d-flex justify-content-center align-items-center flex-column mx-auto">
                    {!isSurveyStarted ? (
                        <div>
                            <h5 className="border-bottom2px">Welcome {responderName}</h5>
                            <div className="shadow bg-white p-5 min-hight400px max-width700px d-flex justify-content-between flex-column">
                                <div>
                                    <h5 className="fs-18">{surveyName}</h5>
                                    <p className="fs-14 text-justify">{description}</p>
                                </div>
                                <div className="text-end">
                                    <button
                                        className="border-0 px-4 py-1 TruveyBG text-white"
                                        onClick={handleStartSurvey}
                                    >
                                        Start Survey
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="shadow bg-white p-5 max-width700px d-flex justify-content-between flex-column">
                            <div>
                                <h5>
                                    {questionDetails[currentQuestionIndex]?.QuestionName}{" "}
                                    <span className="text-danger">*</span>
                                </h5>
                                {renderQuestion(questionDetails[currentQuestionIndex])}
                            </div>
                            <div className="text-end mt-5">
                                <button
                                    className="border-0 px-4 py-1 TruveyBG text-white me-2"
                                    onClick={handlePrevious}
                                    disabled={currentQuestionIndex === 0}
                                >
                                    Previous
                                </button>
                                <button
                                    className="border-0 px-4 py-1 TruveyBG text-white"
                                    onClick={handleNext}
                                    disabled={currentQuestionIndex === questionDetails.length - 1}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserRunSurvey;
